import EditLightbox from './EditLightbox';

export default EditLightbox;
